import { render, staticRenderFns } from "./LayoutPublicRegistration.vue?vue&type=template&id=3892a6ec"
import script from "./LayoutPublicRegistration.vue?vue&type=script&lang=js"
export * from "./LayoutPublicRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports